import { createContext } from "react";
import { SymbolsMetadataManager } from "@shared/types";

export const SymbolsMetadataContext = createContext<
  SymbolsMetadataManager | undefined
>(undefined);
